/* eslint-disable no-unused-vars, no-useless-constructor*/
import React, { Component  } from 'react';
import PropTypes from 'prop-types';

import styles from './Button.css';

import classNames from 'classnames';

class Button extends Component {

	static defaultProps = {
		disabled: false
	};

	constructor(props) {
		super(props);
		this.state = {
			focused: false
		};
	}

	setFocus(focused) {
		this.setState({
			focused: focused
		});
	}

	onClick(e) {
		if (!this.props.disabled) {
			this.props.onClick(e);
		}
	}


	render() {

		let captionInsert = null;
		if (React.Children.count(this.props.children) === 1) {

			captionInsert = (
				<div className="ptr-button-caption">{this.props.children}</div>
			);
		}

		let iconInsert = null;
		if (this.props.icon) {
			// determine icon
			if (this.props.iconFa){
				iconInsert = (<div className="ptr-button-icon">
					<i className={'fa ' + this.props.icon} aria-hidden="true"></i>
				</div>);
			}
		}

		let classes = classNames(
			'ptr-button', {
				control: !!this.props.control,
				disabled: !!this.props.disabled,
				small: !!this.props.small,
				large: !!this.props.large,
				simple: !!this.props.simple,
				noBorder: !!this.props.noBorder,
				primary: !!this.props.primary,
                inverse: !!this.props.inverse,
				secondary: !!this.props.secondary,
				hasIconFa: !!this.props.iconFa,
				hasIcon: !!this.props.icon,
				'icon-right': !!this.props.iconRight,
				'align-center': this.props.alignCenter,
				'align-right': this.props.alignRight,
				focused: this.state.focused,
				'centered': this.props.centered
			},
			this.props.className
		);

		let ret = (
			<div
				className={classes}
				id={this.props.id}
				tabIndex="0"
				onClick={this.onClick.bind(this)}
				onFocus={this.setFocus.bind(this, true)}
				onBlur={this.setFocus.bind(this, false)}
			>
				{iconInsert}
				{captionInsert}
			</div>
		);

		return ret;
	}

}

Button.propTypes = {
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconFa: PropTypes.bool,
    iconRight: PropTypes.bool,
	inverse: PropTypes.bool,
    primary: PropTypes.bool,
    noBorder: PropTypes.bool,
    secondary: PropTypes.bool,
    small: PropTypes.bool,
    alignCenter: PropTypes.bool,
    alignRight: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string
};


export default Button;
